import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i-642010527__Ebene_1",
  viewBox: "0 0 192 192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("desc", null, "Ausweis", -1)),
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".i-642010527__cls-1{fill:none}.i-642010527__cls-2{fill:#2d2d2d}")
        ])),
        _: 1
      }))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M66.46 89.01c6.89 0 12.5-5.61 12.5-12.5s-5.61-12.5-12.5-12.5-12.5 5.61-12.5 12.5 5.61 12.5 12.5 12.5",
      class: "i-642010527__cls-1"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "M174.95 46.03h-156c-1.1 0-2 .9-2 2v95.94c0 1.1.9 2 2 2h156c1.1 0 2-.9 2-2V48.03c0-1.1-.9-2-2-2M66.46 56.02c11.3 0 20.5 9.2 20.5 20.5s-9.2 20.5-20.5 20.5-20.5-9.2-20.5-20.5 9.2-20.5 20.5-20.5m31.16 76.97-5.68-20.46a2.01 2.01 0 0 0-1.93-1.47H42.93c-.89 0-1.69.6-1.93 1.47l-5.71 20.53-7.71-2.14 5.71-20.54c1.2-4.31 5.17-7.32 9.63-7.32H90c4.48 0 8.44 3.01 9.64 7.32l5.68 20.46-7.71 2.14Zm64.82-9h-44.17v-8h44.17zm0-23.97h-44.17v-8h44.17zm0-23.01h-44.17v-8h44.17z",
      class: "i-642010527__cls-1"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      d: "M118.27 68.99h44.17v8h-44.17zM118.27 92.01h44.17v8h-44.17zM66.46 97.01c11.3 0 20.5-9.2 20.5-20.5s-9.2-20.5-20.5-20.5-20.5 9.2-20.5 20.5 9.2 20.5 20.5 20.5m0-33c6.89 0 12.5 5.61 12.5 12.5s-5.61 12.5-12.5 12.5-12.5-5.61-12.5-12.5 5.61-12.5 12.5-12.5M90.01 103.06H42.93c-4.47 0-8.43 3.01-9.63 7.32l-5.71 20.54 7.71 2.14 5.71-20.53c.24-.87 1.03-1.47 1.93-1.47h47.08c.9 0 1.69.6 1.93 1.47l5.68 20.46 7.71-2.14-5.68-20.46c-1.2-4.31-5.16-7.32-9.64-7.32ZM118.27 115.98h44.17v8h-44.17z",
      class: "i-642010527__cls-2"
    }, null, -1)),
    _cache[5] || (_cache[5] = _createElementVNode("path", {
      d: "M174.95 38.03h-156c-5.52 0-10 4.49-10 10v95.94c0 5.51 4.49 10 10 10h156c5.51 0 10-4.49 10-10V48.03c0-5.52-4.49-10-10-10m2 105.94c0 1.1-.9 2-2 2h-156c-1.1 0-2-.9-2-2V48.03c0-1.1.9-2 2-2h156c1.1 0 2 .9 2 2z",
      class: "i-642010527__cls-2"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "identification"}) } }